module.exports = __webpack_public_path__ + "static/media/gamma.eefa3b81.png";